import { Directive } from '@angular/core';

@Directive({
  selector: '[appRutFormater]'
})
export class RutFormaterDirective {

  constructor() { }

}
